import type { Rect } from './state';
export const overlaps = (a: Rect, b: Rect): boolean => a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;

// Continuous relative AABB test. Testing against the unwrapped trajectory
// prevents both tunnelling and false collisions through the middle on wrap.
export function sweptCollision(previous: Rect, current: Rect, object: Rect, dx: number, dy = 0): boolean {
  if (overlaps(previous, object)) return true;
  const vx = current.x - previous.x - dx;
  const vy = current.y - previous.y - dy;
  const axis = (p: number, size: number, q: number, qsize: number, v: number): [number, number] => {
    if (v === 0) return p + size > q && p < q + qsize ? [-Infinity, Infinity] : [Infinity, -Infinity];
    const a = (q - p - size) / v;
    const b = (q + qsize - p) / v;
    return [Math.min(a, b), Math.max(a, b)];
  };
  const [xe, xx] = axis(previous.x, previous.w, object.x, object.w, vx);
  const [ye, yx] = axis(previous.y, previous.h, object.y, object.h, vy);
  const enter = Math.max(xe, ye), leave = Math.min(xx, yx);
  return enter < leave && enter <= 1 && leave >= 0;
}
